<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <table class="table table-striped table-hover">
      <thead class="thead-dark">
        <tr>
          <th>Pickeador</th>
          <th>Fecha inicio</th>
          <th>Fecha Fin</th>
          <th>Ruta</th>
          <th>Categoría</th>
          <th>Subcategoría</th>
          <th>Tipo tarea</th>
          <th class="text-center">Estatus</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="current in dataTabla.results" v-bind:key="current.id" @click="
          rowClick('wms-tarea-usuario-editar', {
            id: current.id,
          })
          ">
          <td>{{ current.pickeador_obj.username }}</td>
          <td>{{ current.fecha_inicio | moment("YYYY-MM-DD hh:mm") }}</td>
          <td>{{ current.fecha_fin | moment("YYYY-MM-DD hh:mm") }}</td>
          <td>
            De {{ current.tienda_origen_obj.nombre }} a
            {{ current.tienda_destino_obj.nombre }}
          </td>
          <td v-if="current.categoria">{{ current.categoria }}</td>
          <td v-if="!current.categoria">-------</td>
          <td v-if="current.sub_categoria">{{ current.sub_categoria }}</td>
          <td v-if="!current.sub_categoria">--------</td>
          <td>{{ current.tarea_tipo }}</td>
          <td class="text-center" v-if="current.estatus == true">
            <span class="badge badge-sm badge-success">Activo</span>
          </td>
          <td class="text-center" v-if="current.estatus == false">
            <span class="badge badge-sm badge-danger">Inactivo</span>
          </td>
        </tr>
      </tbody>
    </table>
    <!-------------------- END - Basic Table -------------------->
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
    };
  },
  props: ["dataTabla"],
  mounted() { },
  methods: {
    rowClick(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      if (event.ctrlKey) {
        let routeUrl = this.$router.resolve({
          name: name,
          params: params,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$router.push({
          name: name,
          params: params,
        });
      }
    },
  },
};
</script>
